import { trackAbTestV2Variant } from 'dibs-ab-tests/exports/clientAbTestV2.ts';

export const HP_AD_NEW_TOP_PLACEMENT_TEST = 'HP_Ad_NewTopPlacement';

export const trackHpAdNewTopPlacementTest = (): void => {
    trackAbTestV2Variant(HP_AD_NEW_TOP_PLACEMENT_TEST);
};
